import { Link, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { clearUrl } from "../features/web/web-slice";
import LoginDashboard from "../Login/LoginPanel";

function Navbar() {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const url = useAppSelector((state) => state.web.url);

	const handleBack = () => {
		if (url) {
			dispatch(clearUrl());
		}
		navigate("/dashboard");
	};

	return (
		<nav className="navbar">
			<div className="navbar__inner">
				<button type="button" className="navbar__brand" onClick={handleBack}>
					<img
						src="/assets/engine.svg"
						alt="Advance Web logo"
						className="navbar__brand-icon"
					/>
					<div className="navbar__brand-text">
						<span>Advance</span>
						<span className="navbar__brand-highlight">Web</span>
					</div>
				</button>

				<div className="navbar__links">
					<Link to="/landing" className="navbar__link">
						Inicio
					</Link>
					<Link to="/dashboard" className="navbar__link" onClick={handleBack}>
						Analizador
					</Link>
				</div>

				<LoginDashboard />
			</div>
		</nav>
	);
}

export default Navbar;
